// Create a new file: frontend/src/slices/featuredProductsSlice.js

import { createSlice } from "@reduxjs/toolkit";

const featuredProductsSlice = createSlice({
    name: 'featuredProducts',
    initialState: {
        loading: false,
        featuredProducts: [],
        error: null
    },
    reducers: {
        featuredProductsRequest(state) {
            state.loading = true;
            state.error = null;
        },
        featuredProductsSuccess(state, action) {
            state.loading = false;
            state.featuredProducts = action.payload;
            state.error = null;
        },
        featuredProductsFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearFeaturedProducts(state) {
            state.featuredProducts = [];
            state.error = null;
        }
    }
});

export const {
    featuredProductsRequest,
    featuredProductsSuccess,
    featuredProductsFail,
    clearFeaturedProducts
} = featuredProductsSlice.actions;

export default featuredProductsSlice.reducer;